import React from "react";
import { IoMdCall } from "react-icons/io";
import "./Contact.css";
import { IoLocationSharp, IoTime } from "react-icons/io5";
import ImageWithSkeleton from "./ImageWithSkeleton";




function Contact() {
  const owners = [
    {
      name: "Chandu Faldu",
      designation: "Founder & Owner",
      expert: "35+ Years Experience",
      phone: "+91 97732 55243",
      image: "/assets/owner/chandu.jpeg",
      whatsappUrl: `https://wa.me/919426212650?text=${encodeURIComponent("નમસ્તે, હું વિનાયક એગ્રો કેમિકલ્સના ઉત્પાદનો વિશે માહિતી અને ઉપલબ્ધતા જાણવા માંગું છું. કૃપા કરીને માર્ગદર્શન આપશો.")}`,
      callUrl: "tel:+919773255243"
    },
    {
      name: "Jaydip Faldu",
      designation: "CEO & Managing Director",
      expert: "15+ Years Experience",
      phone: "+91 82641 91234",
      image: "/assets/owner/jaydip.jpeg",
      whatsappUrl: `https://wa.me/918264191234?text=${encodeURIComponent("નમસ્તે, હું વિનાયક એગ્રો કેમિકલ્સના ઉત્પાદનો વિશે માહિતી અને ઉપલબ્ધતા જાણવા માંગું છું. કૃપા કરીને માર્ગદર્શન આપશો.")}`,
      callUrl: "tel:+918264191234"
    },
  ];

  const mapEmbedUrl = "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3521.7614360104435!2d72.1425426!3d21.7769322!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395f5b4248d8f917%3A0xad352c025fe2b584!2sVinayak%20Agro%20Chemicals!5e1!3m2!1sen!2sin!4v1780809758725!5m2!1sen!2sin";

  return (
    <div className="contact-page-container">
      {/* Page Hero Banner */}
      <div className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-title">Contact Us</h1>
          <p className="page-subtitle">Get in touch or visit our store in Bhavnagar</p>
        </div>
      </div>

      <section className="contact-section">
        <div className="contact-container">
          <span className="section-tag">Reach Us</span>
          <h2 className="section-title">Get in Touch</h2>
          <p className="section-subtitle">We are here to help you. Choose how you want to connect.</p>

          <div className="contact-main-grid">
            
            {/* Owner Cards Column */}
            <div className="contact-column owners-col">
              <h3 className="column-title">Direct Contact</h3>
              <div className="contact-owners-list">
                {owners.map((owner, idx) => (
                  <div key={idx} className="owner-card">
                    <div className="owner-header">
                      <div className="owner-photo-placeholder">
                        <ImageWithSkeleton
                          src={owner.image}
                          alt={owner.name}
                          className="owner-photo-img"
                          fallbackIcon={owner.name.split(' ').map(n => n[0]).join('')}
                          fallbackClassName="owner-photo-initials"
                        />
                      </div>
                      <div className="owner-meta">
                        <h4 className="owner-name">{owner.name}</h4>
                        <p className="owner-designation">{owner.designation}</p>
                        <p className="owner-expert">{owner.expert}</p>
                      </div>
                    </div>
                    <div className="owner-body">
                      <p className="owner-phone"><IoMdCall /> {owner.phone}</p>
                      <div className="owner-actions">
                        <a href={owner.whatsappUrl} target="_blank" rel="noopener noreferrer" className="owner-btn whatsapp-action">
                          WhatsApp
                        </a>
                        <a href={owner.callUrl} className="owner-btn call-action">
                          Call Now
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Map & Info Column */}
            <div className="contact-column map-info-col">
              <h3 className="column-title">Our Location & Hours</h3>
              
              {/* Map Box */}
              <div className="map-card-wrapper">
                <div className="map-iframe-container">
                  <iframe 
                    title="Vinayak Agro Chemicals Store Location"
                    src={mapEmbedUrl}
                    width="100%" 
                    height="280" 
                    style={{ border: 0 }} 
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>

              {/* Business Hours & Address Card */}
              <div className="info-cards-grid">
                <div className="address-info-card">
                  <div className="info-icon"><IoLocationSharp /></div>
                  <div className="info-details">
                    <h4>Shop Address</h4>
                    <p>30, Manimahal Shopping Center,</p>
                    <p>Darbari Kothar Road,</p>
                    <p>Bhavnagar, Gujarat - 364001</p>
                  </div>
                </div>

                <div className="hours-info-card">
                  <div className="info-icon"><IoTime /></div>
                  <div className="info-details">
                    <h4>Business Hours</h4>
                    <p><strong>Monday – Saturday:</strong> 7:30 AM – 8:00 PM</p>
                    <p><strong>Sunday:</strong> <span className="closed-text">Closed</span></p>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
